export interface Tier {
  id: string;
  minScore: number;
  labelKo: string;
  /** One-line ending narrative shown on the summary screen when the village settles at this tier. */
  outroKo: string;
  fogColor: string;
  fogNear: number;
  fogFar: number;
  lightColor: string;
  lightIntensity: number;
  treeColor: string;
  riverColor: string;
  /** 0 = no smog, 1 = maximum smog particle opacity/spread */
  smogDensity: number;
}

export const TIERS: Tier[] = [
  {
    id: 'ruin',
    minScore: 0,
    labelKo: '폐허',
    outroKo: '마을이 아직 위험해요... 다시 도전해서 마을을 구해볼까요?',
    fogColor: '#5c4632',
    fogNear: 3,
    fogFar: 16,
    lightColor: '#caa06a',
    lightIntensity: 0.55,
    treeColor: '#6b5a3a',
    riverColor: '#4a3c26',
    smogDensity: 1,
  },
  {
    id: 'polluted',
    minScore: 21,
    labelKo: '오염',
    outroKo: '마을에 아직 쓰레기가 많이 남아있어요. 조금만 더 힘내볼까요?',
    fogColor: '#7a7460',
    fogNear: 6,
    fogFar: 22,
    lightColor: '#d8c491',
    lightIntensity: 0.8,
    treeColor: '#7c8a4a',
    riverColor: '#5e6b4a',
    smogDensity: 0.6,
  },
  {
    id: 'neutral',
    minScore: 41,
    labelKo: '보통',
    outroKo: '마을이 조금씩 나아지고 있어요. 계속 분리배출을 실천해봐요!',
    fogColor: '#9aa08c',
    fogNear: 10,
    fogFar: 32,
    lightColor: '#eee7c9',
    lightIntensity: 1.0,
    treeColor: '#5f9a52',
    riverColor: '#4d84a3',
    smogDensity: 0.3,
  },
  {
    id: 'recovering',
    minScore: 61,
    labelKo: '회복중',
    outroKo: '마을이 눈에 띄게 깨끗해졌어요! 조금만 더 힘내면 완전히 되살아나요.',
    fogColor: '#bcd2c6',
    fogNear: 14,
    fogFar: 42,
    lightColor: '#f5f2df',
    lightIntensity: 1.2,
    treeColor: '#4caf50',
    riverColor: '#3aa0c8',
    smogDensity: 0.1,
  },
  {
    id: 'clean',
    minScore: 81,
    labelKo: '청정마을',
    outroKo: '마을이 다시 숨쉬기 시작했어요! 여러분 덕분이에요 🌱',
    fogColor: '#cfe8ff',
    fogNear: 18,
    fogFar: 56,
    lightColor: '#ffffff',
    lightIntensity: 1.4,
    treeColor: '#3fae4a',
    riverColor: '#2fb6e0',
    smogDensity: 0,
  },
];

export function tierForScore(score: number): Tier {
  let match = TIERS[0];
  for (const tier of TIERS) {
    if (score >= tier.minScore) match = tier;
  }
  return match;
}

export function tierIndexForScore(score: number): number {
  let index = 0;
  for (let i = 0; i < TIERS.length; i += 1) {
    if (score >= TIERS[i].minScore) index = i;
  }
  return index;
}
